<template>
  <div class="personal-info">
    <span> اطلاعات تماس </span>

    <AccountField v-model="data.email" label="ایمیل" ltr disabled>
      <template #append>
        <button
          class="edit-btn"
          type="button"
          @click="(showModal = true), (isMobile = false)"
        >
          <inline-svg
            fill="#fff"
            width="20px"
            :src="require('@/assets/pen-alt-solid.svg')"
          />
        </button>
      </template>
    </AccountField>
    <AccountField
      v-model="data.mobileNumber"
      label="شماره موبایل"
      type="number"
      :maxLength="11"
      ltr
      :disabled="
        countryName != 'Iran' ||
        !['UNAUTHORIZED', 'UNIDENTIFIED', 'NOT_COMPLETE'].includes(
          data.authenticationType
        )
      "
    >
      <template #append>
        <button
          v-if="
            countryName != 'Iran' ||
            !['UNAUTHORIZED', 'UNIDENTIFIED', 'NOT_COMPLETE'].includes(
              data.authenticationType
            )
          "
          class="edit-btn"
          type="button"
          @click="(showModal = true), (isMobile = true)"
        >
          <inline-svg
            fill="#fff"
            width="20px"
            :src="require('@/assets/pen-alt-solid.svg')"
          />
        </button>
      </template>
    </AccountField>
    <AccountField
      v-if="countryName == 'Iran'"
      v-model="data.telephone"
      label="تلفن ثابت"
      type="number"
      :maxLength="11"
      ltr
    />
    <AccountField
      v-model="data.postalCode"
      label="کد پستی"
      type="number"
      :maxLength="countryName == 'Iran' ? 10 : 20"
      ltr
    />
    <AccountField v-model="data.address" label="آدرس" />
    <edit-modal
      v-if="showModal"
      :data="data"
      :isMobile="isMobile"
      :countryPhoneCode="countryPhoneCode"
      :isIran="countryName == 'Iran'"
      @close="showModal = false"
      @changedMobile="data.mobileNumber = $event.replace(countryPhoneCode, '0')"
      @changedEmail="data.email = $event"
    />
  </div>
</template>

<script>
import AccountField from "./AccountField.vue";
import EditModal from "./EditModal.vue";

export default {
  name: "PhoneInfo",
  components: { AccountField, EditModal },
  props: ["data", "countryName", "countryPhoneCode"],
  data() {
    return {
      showModal: false,
      isMobile: false,
    };
  },
  watch: {
    countryPhoneCode(val) {
      if (this.data.mobileNumber && this.data.mobileNumber.includes(val)) {
        this.data.mobileNumber = this.data.mobileNumber.replace(
          val,
          // ""
          "0"
        );
      } else {
        this.data.mobileNumber = "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ac-input {
  border-radius: 4px;
  // overflow: hidden;
  .bd {
    input {
      width: 100%;
    }
  }
  display: flex;
  flex-direction: column;
  row-gap: 3px;
  width: 100%;
  .active-span {
    color: var(--primary-color);
    transform: translateY(-25px);
  }
  label {
    display: flex;
    flex-direction: row;
    background: var(--light-grey);
    padding: 8px 12px;
    border-radius: 4px;
    position: relative;
    input {
      background: transparent;
      width: 80%;
      z-index: 2;
    }
    span {
      transform: translateY(0px);
      font-weight: 400;
      font-size: clamp(12px, 2vw, 14px);
      transition: 500ms;
      position: absolute;
    }
  }
}
span {
  font-weight: 400;
  font-size: clamp(14px, 2vw, 18px);
}
.personal-info {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  padding: 24px;
  background: var(--box);
  border-radius: 12px;
  width: 100%;
  input {
    width: 100% !important;
  }
}
.edit-btn {
  background-color: var(--primary-color);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25px;
  height: 25px;
  border-radius: 5px;
  cursor: pointer;
  margin-right: 8px;
}
</style>
